import { useEffect, useState } from 'react'

import http from '../config/http'

type TProps = {
  uuid: string
}

type TSignatures = {
  driverSignedAt: string | null
  dispatcherSignedAt: string | null
  errorMessage: string
  number: string
}

const useVerifySgnatures = ({ uuid }: TProps) => {
  const [signatures, setSignatures] = useState<TSignatures>({
    driverSignedAt: null,
    dispatcherSignedAt: null,
    errorMessage: '',
    number: ''
  })

  useEffect(() => {
    if (uuid) {
      http
        .get<TSignatures>(`order-ops/romaneio/sign-dates/${uuid}`)
        .then((res) => setSignatures(res.data))
        .catch((err) => console.error(err))
    }
  }, [uuid])

  return { signatures }
}

export default useVerifySgnatures
